// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound404_wrapper__QSV8o","heading":"NotFound404_heading__demGf","text":"NotFound404_text__xHj94","M404":"NotFound404_M404__yiRR5","button":"NotFound404_button__ExfeP"};